import { createSlice } from '@reduxjs/toolkit';
import api from 'services/api';

const initialState = {
  searchResults: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  loading: false,
  error: null,
};

const userSearchSlice = createSlice({
  name: 'userSearch',
  initialState,
  reducers: {
    searchUsersRequest: state => {
      state.loading = true;
      state.error = null;
    },
    searchUsersSuccess: (state, action) => {
      state.loading = false;
      state.searchResults = action.payload;
    },
    searchUsersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearSearchResults: state => {
      state.searchResults = initialState.searchResults;
      state.error = null;
    },
  },
});

// Action creators
export const { searchUsersRequest, searchUsersSuccess, searchUsersFailure, clearSearchResults } =
  userSearchSlice.actions;

// Thunk actions
export const searchUsers = params => async dispatch => {
  try {
    dispatch(searchUsersRequest());
    const response = await api.get('/api/management-panel/user-search/', { params });
    dispatch(searchUsersSuccess(response.data));
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Search failed';
    dispatch(searchUsersFailure(errorMessage));
    throw error;
  }
};

// Selectors
export const selectors = {
  getSearchResults: state => state.userSearch.searchResults,
  isLoading: state => state.userSearch.loading,
  getError: state => state.userSearch.error,
};

export const actions = {
  searchUsers,
  clearSearchResults,
};

export default userSearchSlice.reducer;
